import { inject } from 'inversify';
import { Injectable } from '../../decorators/injectable';
import { HttpService, type IHttpService } from '../http/http.service';
import type {
  IConsentService,
  UpdateConsentRequest,
  UserConsentStatus,
} from './consent.service.interface';

@Injectable()
export class ConsentService implements IConsentService {
  constructor(@inject(HttpService) private readonly http: IHttpService) {}

  async getUserConsents(): Promise<UserConsentStatus[]> {
    return this.http.get<UserConsentStatus[]>('consent');
  }

  async updateConsent(data: UpdateConsentRequest): Promise<UserConsentStatus[]> {
    return this.http.patch<UserConsentStatus[]>('consent', data);
  }
}
